import React from "react";

const Ticket = ({ width = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 26.22 24.45"
    fill={"#fff"}
    width={width}
  >
    <path d="M21.12,16.18l1.67-1.1,1.37,2.08,2.06-1.35L15.81,0,13.76,1.35l2.77,4.21-1.67,1.1L12.09,2.45,0,10.41l3.87,5.88.21-.17c1.82-1.2,5.06.51,7.23,3.81a11,11,0,0,1,1.78,4.52l9.4-6.19ZM15.94,8.31l1.67-1.1,3.94,6-1.67,1.1Z" />
  </svg>
);

export default Ticket;
